import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity OfficePartner
 */
@Entity()
export class Office extends Partner {
  static override _class = 'OfficePartner';

  override get type() {
    return KooperationsPartner.OFFICE;
  }
}
